import { useEffect, useState } from 'react'
import { Alert, Container } from '@mui/material'
import ConfluencePageArticle from '../components/ConfluencePageArticle'
import { ConfluencePage } from '../types'
import { useTranslation } from 'react-i18next'
import LoadingState from '../components/LoadingState'
import { ConfluencePages } from '../enums'
import { getConfluencePage } from '../services/confluenceService'
import ConfluencePageHeader from '../components/ConfluencePageHeader'

export default function Changelog(): JSX.Element {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  /**
   * The page.
   */
  const [page, setPage] = useState<ConfluencePage>()

  /**
   * Indicates if the page is loading.
   */
  const [isLoading, setIsLoading] = useState<boolean>(true)

  /**
   * The error.
   */
  const [error, setError] = useState<unknown>()

  /**
   * Indicates if there was an error.
   */
  const isError = error !== undefined

  /**
   * Loads the page.
   */
  async function loadPage(id: string, signal?: AbortSignal): Promise<void> {
    try {
      setIsLoading(true)
      setError(undefined)

      const page = await getConfluencePage(id, {
        params: {
          'body-format': 'view'
        },
        signal
      })

      setPage(page)
    } catch (error) {
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * Runs when the component mounts.
   */
  useEffect(() => {
    const controller = new AbortController()

    loadPage(ConfluencePages.CHANGELOG, controller.signal)

    return () => controller.abort()
  }, [])

  return (
    <Container maxWidth="md">
      <ConfluencePageHeader page={page} title={t('changelog')} />

      {isError ? (
        <Alert severity="error">{t('somethingWentWrong')}</Alert>
      ) : isLoading || page === undefined ? (
        <LoadingState />
      ) : (
        <ConfluencePageArticle page={page} />
      )}
    </Container>
  )
}
